<mat-card appearance="outlined" class="mat-elevation-z4">
    <mat-card-content>
        <form [formGroup]="formGroup" class="form-horizontal">
            <div class="row">
                <div class="col-lg-12">
                    <sl-input type="text" placeholderKey="General.Description" [control]="formGroup.controls['description']" />
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <sl-input type="text" placeholderKey="General.Group" [control]="formGroup.controls['group']" />
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <span>{{ 'FileUpload.SelectFile' | translate }}</span>
                    <input type="file" (change)="reportFileSelected($event)" />
                    <br />
                    <span>{{ formGroup.value.fileName }}</span>
                </div>
            </div>
        </form>
    </mat-card-content>
</mat-card>
